import { ParentState } from "@hopper-b2b/checkout";
import type { FlightMachineContext } from "../types";

export const paymentGuards = {
  notVisitedPayment: (ctx: FlightMachineContext, _event) =>
    !ctx[ParentState.payment].visited,
};
